import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';


Vue.use(VueResource);

Vue.http.interceptors.push(function(request, next) {

  // modify headers
  if(window.wpApiSettings && window.wpApiSettings.nonce)
    request.headers.set('X-WP-Nonce', window.wpApiSettings.nonce);

  // continue to next interceptor
  next();
});



new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js